import { render } from "./SubmitOrderBar.vue?vue&type=template&id=568b36fa&scoped=true"
import script from "./SubmitOrderBar.vue?vue&type=script&lang=js"
export * from "./SubmitOrderBar.vue?vue&type=script&lang=js"

import "./SubmitOrderBar.vue?vue&type=style&index=0&id=568b36fa&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568b36fa"]])

export default __exports__